import PushNotificationActionCreator from "@/helpers/push/creators/PushNotificationActionCreator";
import OpenChatAction from "@/helpers/push/actions/OpenChatAction";
export default class GoToActionCreator extends PushNotificationActionCreator {
    payload;
    constructor(payload) {
        super();
        this.payload = payload;
    }
    create() {
        return new OpenChatAction(this.payload.contactId, this.payload.messageId);
    }
}
